import React, { Component } from 'react';
import { Switch, Button, Input, Upload, message, Divider } from 'antd';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";
import { SvgIconText } from 'freesia-ui';
// import DataSourceSelectDialog from '../../../datasource/common/DataSourceSelectDialog';
// import CrumbstyleDataSourceAndMyDataDialog from '../../../executor/navigator/CrumbstyleDataSourceAndMyDataDialog';

export default class DataSourceAndMyDataSelectorEditor extends PropertyEditor {

    state = {
        dataSourceSelectVisible: false,
        datasource: null,
        displayName: ''
    };

    constructor(props, context) {
        super(props, context);
    }

    onChange(e) {
        this.props.source.value = e;
        this.setState({});
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({});
    }

    showTableSel() {
        this.setState({
            dataSourceSelectVisible: true
        })
    }

    hideDataSourceSelectModal() {
        this.setState({
            dataSourceSelectVisible: false
        })
    }

    onSelectedSubmit(item) {
        this.props.source.value = item;

        this.setState({ displayName: ("ds" in item) ? item.dsName : "我的数据" });
        this.hideDataSourceSelectModal();
    }

    render() {
        let { dataSourceSelectVisible, displayName } = this.state;
        let source = this.props.source;

        return (
            <div>
                <Button className="hstretch" onClick={e => this.showTableSel()} title={displayName || this.props.source.value && this.props.source.value.dsName} style={{ padding: "3px 7px 3px 10px", textAlign: "left" }}>
                    <div className="hstretch text-nowrap">{displayName || this.props.source.value && this.props.source.value.dsName}</div>
                </Button>
                {/* <DataSourceSelectDialog
                    visible={dataSourceSelectVisible}
                    onSelectedSubmit={this.onSelectedSubmit.bind(this)}
                    afterClose={this.hideDataSourceSelectModal.bind(this)}
                    onCancle={this.hideDataSourceSelectModal.bind(this)} /> */}

                {/* <CrumbstyleDataSourceAndMyDataDialog
                    visible={dataSourceSelectVisible}
                    onSuccess={c => this.onSelectedSubmit(c)}
                    onCancel={() => { this.hideDataSourceSelectModal() }} /> */}
            </div>
        );
    }
}

PropertyGridUtils.register("datasource-mydata-selector", (source, propertyGrid) => <DataSourceAndMyDataSelectorEditor source={source} propertyGrid={propertyGrid} />);